import React, { LegacyRef, forwardRef } from 'react';
import { CommonModal } from '../Modal/CommonModal';
import ReCAPTCHA from '@9swampy/react-google-recaptcha';

import styles from './index.module.scss';
import { useTheme } from '@/hooks';

type Props = {
  on: boolean;
  turnOff: () => void;
  onChange: (token: string | null) => void;
  action: string;
};

export const ReCaptchaModal = forwardRef((props: Props, ref: LegacyRef<ReCAPTCHA>) => {
  const { on, turnOff, onChange } = props;
  const { isDark } = useTheme();
  return (
    <CommonModal containerClassName={styles.modalContainer} on={on} turnOff={turnOff}>
      <ReCAPTCHA
        ref={ref}
        onChange={onChange}
        hl="en"
        style={{
          transform: 'scale(1)',
          transformOrigin: '0 0',
        }}
        theme={isDark ? 'dark' : 'light'}
        sitekey="6Lcw7ewpAAAAAPtZi4LTNCAWmWj-1h5ACTD_CQHE"
        // data-action={action}
        data-action="USER_LOGIN"
      />
    </CommonModal>
  );
});
